const CONFIG = {
  BASE_URL: 'https://restaurant-api.dicoding.dev',
  IMAGE_SMALL: 'https://restaurant-api.dicoding.dev/images/small',
  IMAGE_MEDIUM: 'https://restaurant-api.dicoding.dev/images/medium',
  IMAGE_LARGE: 'https://restaurant-api.dicoding.dev/images/large',
  DATABASE_NAME: 'restaurant-database',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'restaurant',
};

export default CONFIG;
